import React, { useState, useEffect, useMemo } from 'react'
import classNames from 'classnames'
import Pro from 'image/detail/pro2.png'
import { isEqual } from 'lodash'
import { Dropdown } from 'meinian-package/src/baseComponent'
import { NewSearch } from 'meinian-package/src/baseComponent/input'
import Icon from 'meinian-package/src/component/icon'
import styles from './index.module.less'

export default ({ option, value, onChange }) => {
  return <div className={styles['mn-detail-inspiration-select']}>
    <Select
      displayStyle={{ color: 'var(--m-text-1)', fontWeight: '600', }}
      allowClear={false}
      options={option}
      placeholder="美念"
      value={value}
      onChange={onChange}
      container={document.body}
      trigger="hover"
    />
  </div>
}

const Select = (props) => {
  const { onChange, placement, disabled, ulStyle, container, options, value, placeholder, allowClear, trigger } = props
  const [visible, setVisible] = useState(false)
  const onOk = (val, item) => {
    onChange && onChange(val, item)
    setVisible(false)
  }
  const onClear = () => {
    onChange && onChange(null)
    setVisible(false)
  }
  return <Dropdown
    getPopupContainer={triggerNode => container || triggerNode}
    trigger={trigger}
    overlay={<List
      value={value}
      maxLevel={3}
      options={options}
      onChange={onOk}
      onOk={onOk}
      onClear={onClear}
      visible={visible}
      style={ulStyle}
    />}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
    disabled={disabled}
  >
    <span>
      <SelectDisplay
        options={options}
        allowClear={allowClear}
        placeholder={placeholder}
        value={value}
        visible={visible}
        onClear={onClear}
      />
    </span>
  </Dropdown>
}

const SelectDisplay = (props) => {
  const { className, displayStyle, value = null, options = [], placeholder = '请选择', visible, inner, onClear, allowClear = true, prefix } = props
  return <span className={classNames(styles['inspiration-select-meinian-select-display'], className, { visible, active: (value || value === 0) && allowClear, inner })} style={displayStyle}>
    <span className="line-1">{prefix}{options.find(m => value === m.value)?.label || placeholder}</span>
    {visible ? <Icon type="m-Vxing_shang" /> : <Icon type="m-Vxing_xia" />}
    {(value || value === 0) && allowClear ? <Icon type="m-guanbi_tianchong" className="clear-icon" onClick={(e) => { e && e.stopPropagation(); onClear() }} /> : null}
  </span>
}

const List = (props) => {
  const { style, options = [], value = null, visible, onChange, maxLevel } = props
  const [levels, setLevels] = useState([])
  const [keysWords, setKeyWords] = useState('')
  useEffect(() => {
    setLevels(!value ? [] : getLevels(findItemByValue(value, options)))
  }, [visible])

  const _options = useMemo(() => {
    return options.filter(item => item.label.includes(keysWords))
  }, [keysWords])

  return <div className={styles['mn-inspiration-list']} style={{ maxHeight: 500, ...style }}>
    <div className="mn-inspiration-list-wrap">
      <NewSearch
        value={keysWords}
        onClear={() => setKeyWords('')}
        onChange={val => setKeyWords(val)}
        onMouseEnter={() => setLevels([])}
        wrapStyle={{ borderRadius: '6px', marginBottom: '8px' }}
      />
      {_options?.map(item => <div
        key={item.value}
        className={classNames('mn-inspiration-list-wrap-item', { active: isEqual(value, item.value) || levels.includes(item.value), disabled: item.disabled })}
        onClick={() => {
          onChange && onChange(item.value, item)
        }}
        onMouseEnter={() => setLevels([item.value])}
      >
        {item.isPro ? <img
          src={Pro}
          style={{ width: '34px', height: '18px', marginRight: '4px', marginTop: '-2px' }}
        /> : null}
        <div className="mn-inspiration-list-wrap-item-label">{item.label}</div>
        {
          item.childs && !!item.childs.length && <Icon type="m-Vxing_you" />
        }
      </div>)}
    </div>
    {levels.map((level, index) => {
      const o = findItemByValue(level, options)?.childs
      if (!(o && o.length)) return null
      return <div className="mn-inspiration-list-wrap">
        {o.map(item => <div
          className={classNames('mn-inspiration-list-wrap-item', { active: isEqual(value, item.value) || levels.includes(item.value) })}
          onClick={() => onChange?.(item.value, item)}
          onMouseEnter={() => {
            setLevels(pre => {
              const _levels = [...pre.slice(0, index + 1), item.value]
              if (_levels.findIndex(i => i === item.value) < maxLevel - 1) {
                return _levels
              }
              return [...pre]
            })
          }}
        >
          <div className="mn-inspiration-list-wrap-item-label">{item.label}</div>
          {
          item.childs && !!item.childs.length && levels.findIndex(i => i === level) < maxLevel - 2 && <Icon type="m-Vxing_you" />
        }
        </div>)}
      </div>
    })}
  </div>
}

const getLevels = (item) => {
  if (!item) return []
  const levels = []
  if (item.parent) {
    levels.unshift(item.parent.value)
    const l = getLevels(item.parent)
    if (l.length) {
      levels.unshift(...l)
    }
  }
  return levels
}

const findItemByValue = (value, options = []) => {
  const item = options.find(m => isEqual(m.value, value))
  if (item) return item
  // eslint-disable-next-line no-shadow
  for (const item of options) {
    const sonItem = findItemByValue(value, item.childs)
    if (sonItem) return sonItem
  }
}
